import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Service from "./pages/Service";
//import MaintenancePage from "./components/MaintenancePage";

const App: React.FC = () => {
  /*
  const urlParams = new URLSearchParams(window.location.search);
  const hasShowContent = urlParams.has("show-content");
  const sessionShowContent = sessionStorage.getItem("show-content") === "true";

  React.useEffect(() => {
    if (hasShowContent) {
      sessionStorage.setItem("show-content", "true");
    }
  }, [hasShowContent]);

  if (!hasShowContent && !sessionShowContent) {
    return <MaintenancePage />;
  }*/

  return (
    <Router>
      <div className="App">
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/service/:slug" element={<Service />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
